.wrap {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.row { flex-direction: row; }
.col { flex-direction: column; }

.chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background: var(--color-bone);
  border: 1px solid rgba(0, 0, 0, 0.06);
  min-width: 0;
}

.flag {
  font-size: 1.1em;
  line-height: 1;
}

.body {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
  min-width: 0;
}

.label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: var(--color-ink-soft);
  text-transform: uppercase;
}

.qty {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-ink);
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}

.sm { font-size: 0.85em; }
.sm .chip { padding: 6px 10px; gap: 6px; }
.lg .chip { padding: 10px 14px; gap: 10px; }

.ok      .dot { background: #2e9d57; box-shadow: 0 0 0 3px rgba(46, 157, 87, 0.15); }
.low     .dot { background: #f39a2e; box-shadow: 0 0 0 3px rgba(243, 154, 46, 0.18); }
.out     .dot { background: #b53b3b; box-shadow: 0 0 0 3px rgba(181, 59, 59, 0.18); }
.unknown .dot { background: #9aa0a6; }

.out .qty { color: #7a2828; }
.low .qty { color: var(--color-ember-dark); }

.col .chip { width: 100%; border-radius: 10px; justify-content: flex-start; }

@media (max-width: 540px) {
  .row { flex-direction: column; align-items: stretch; }
  .row .chip { width: 100%; border-radius: 10px; }
}
